export const ERROR_TYPES = [
  'generic',
  'network',
  'auth',
  'server',
  'not_found',
  /** Convidado já cadastrado com biometria — repetir o funil não muda nada. */
  'already_onboarded',
] as const;

export type ErrorType = (typeof ERROR_TYPES)[number];

export type ErrorLocationState = {
  errorType: ErrorType;
  errorCode?: string;
  errorMessage?: string;
  originPath?: string;
  originState?: unknown;
  canRetry?: boolean;
};

const DEFAULT_ERROR_STATE: ErrorLocationState = {
  errorType: 'generic',
};

function isErrorType(value: unknown): value is ErrorType {
  return (
    typeof value === 'string' &&
    (ERROR_TYPES as readonly string[]).includes(value)
  );
}

export function isErrorLocationState(state: unknown): state is ErrorLocationState {
  if (typeof state !== 'object' || state === null) {
    return false;
  }
  return isErrorType((state as ErrorLocationState).errorType);
}

function resolveCanRetry(state: ErrorLocationState): boolean | undefined {
  if (state.canRetry !== undefined) {
    return state.canRetry;
  }
  if (state.errorType === 'auth' || state.errorType === 'already_onboarded') {
    return false;
  }
  if (state.originPath) {
    return true;
  }
  return undefined;
}

export function parseErrorLocationState(state: unknown): ErrorLocationState {
  if (!isErrorLocationState(state)) {
    return { ...DEFAULT_ERROR_STATE };
  }

  const parsed: ErrorLocationState = {
    errorType: state.errorType,
    ...(state.errorCode !== undefined ? { errorCode: state.errorCode } : {}),
    ...(state.errorMessage !== undefined
      ? { errorMessage: state.errorMessage }
      : {}),
    ...(state.originPath !== undefined ? { originPath: state.originPath } : {}),
    ...(state.originState !== undefined ? { originState: state.originState } : {}),
  };

  const canRetry = resolveCanRetry({ ...parsed, canRetry: state.canRetry });
  if (canRetry !== undefined) {
    parsed.canRetry = canRetry;
  }

  return parsed;
}
